import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, Button, Row, Col, Input, Select, Radio, Divider, message } from 'antd';
import { addDept, modifyDept } from '../../../services/api';

message.config({
  duration: 1.5
})

const StyledForm = styled(Form)`
  
  .ant-input {
    border-radius: 5px;
  }

  .ant-select-selector {
    border-radius: 5px!important;
  }
`;

const ModalContainer = ({set_s_showModal, s_DepartmentData}) => {

  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields()
  }, [form, s_DepartmentData]);

  const onSubmit = async values => {

    const type = Object.keys(s_DepartmentData).length === 0 ? 'create' : 'modify';

    if(type === 'create') {
      // 新增部門資料
      const res = await addDept(values);
      res.status ? message.success(res.msg) : message.error(res.msg);
      set_s_showModal(false);
    };

    if(type === 'modify') {
      // 修改部門資料
      const res = await modifyDept(values);
      res.status ? message.success(res.msg) : message.error(res.msg);
      set_s_showModal(false);
    };
    
    
  }

  const handleCancel = () => {
    set_s_showModal(false)
  }

  return (
    <>
      <StyledForm
        onFinish={onSubmit}
        name="basic"
        form={form}
        autoComplete="off"
        layout="vertical"
        initialValues={{
          deptID: Object.keys(s_DepartmentData).length > 0 ? s_DepartmentData.deptID : '',
          deptNM: Object.keys(s_DepartmentData).length > 0 ? s_DepartmentData.deptNM : '', 
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item 
              label={<label style={{color: '#6C6C6C'}}>部門ID</label>}
              name="deptID"
              rules={Object.keys(s_DepartmentData).length === 0 ? [{ required: true, message: '請填寫部門ID!' }] : null}
            >
                <Input disabled={Object.keys(s_DepartmentData).length === 0 ? false : true} name='deptID' placeholder="請填寫部門ID" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item 
              label={<label style={{color: '#6C6C6C'}}>部門名稱</label>}
              name="deptNM"
              rules={[{ required: true, message: '請填寫部門名稱!' }]}
            >
              <Input name='deptNM' placeholder="請填寫部門名稱" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div style={{display: 'flex',justifyContent: 'flex-end'}}>
              <Button size='large' style={{marginRight: '20px', borderRadius: '5px'}} onClick={handleCancel}>
                取消
              </Button>
              <Form.Item>
                <Button size='large' type="primary" htmlType="submit" style={{borderRadius: '5px'}}>
                  確定
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>
      </StyledForm>
    </>
  )
};
export default ModalContainer